// extracted by mini-css-extract-plugin
module.exports = {"page":"Ty-z","cartModal":"Uy-z","checkout":"Vy-z","placeholder":"Wy-z","account":"Xy-z"};